import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import strings from 'owa-strings/owa-mail-strings';
import { ActionSource } from 'owa-mail-store';
import { format } from 'owa-strings';
import { MAX_LABEL_ITEM_COUNT } from 'owa-mail-store/lib/utils/bulkTriageConstants';
import { trace } from 'owa-trace';

/**
 * Gets the confirm text for delete all dialog.
 * @param actionSource Action that initiated the delete all action
 * @param listViewType The view type of the folder being deleted
 * @param totalCount The total count of items in folder
 * @returns The text shown in delete all confirmation dialog
 */
export default function getDeleteAllConfirmText(
    actionSource: ActionSource,
    listViewType: ReactListViewType,
    totalCount: number
): string {
    const isMessageView = listViewType === ReactListViewType.Message;

    /**
     * Special-case "ContextFolder" because the TotalCount received from the
     * Folder object is always message count.
     */
    const useItemStrings = actionSource === 'ContextFolder' || isMessageView;

    if (totalCount == 0) {
        trace.warn('getDeleteAllConfirmText should not be called.');
        return '';
    } else if (totalCount == 1) {
        return strings.deleteItem;
    } else if (totalCount < MAX_LABEL_ITEM_COUNT) {
        return useItemStrings
            ? format(strings.deleteNumberOfItems, totalCount)
            : format(strings.deleteNumberOfConversations, totalCount);
    } else {
        return useItemStrings
            ? format(strings.deleteNumberOfItems, '10000+')
            : format(strings.deleteNumberOfConversations, '10000+');
    }
}
